import React from "react";
import classes from "./Navbar.module.css";

import { BiUserCircle } from 'react-icons/bi';


function Navbar(props) {
  return (
    <nav className={classes.nav}>
      <a href="/"><BiUserCircle size={40} /></a>
    </nav>
  );
}

export default Navbar;

// {props.isLoggedIn && ()}  {props.isLoggedIn && ()} {props.isLoggedIn && ()}